<app-half-background [images]="dhlBackground" [shadow]="false" alt="DHL search background">
    <ng-container contain>
        <section class="search content">
            <div class="search-form-container container sticky-top">
                <div class="d-flex align-items-center flex-column">
                    <div class="search-logo d-sm-block d-none">
                        <app-facility-logo [width]="'313'" [height]="'121'"></app-facility-logo>
                    </div>
                    <h1 class="mat-headline-4 mt-5">Welcome to our customer portal</h1>
                </div>
                <div class="form-inputs">
                    <app-search> </app-search>
                </div>
            </div>
        </section>
    </ng-container>
</app-half-background>
